// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qTqh","icon":"styles_icon__y_Fib"};